import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 24px;

  table {
    border-collapse:collapse;
    tr {
      th {
        text-align: left;
        text-transform: uppercase;
        width: 50%;
        ${getBodyStyle('graphikCompact', { default: 'small' }, 'light')}
      }

      td {
        text-align: right;
        ${getBodyStyle('graphikCompact', { default: 'medium' }, 'bold')}
      }

      th, td {
        border-bottom: 1px solid ${getColor('borderSecondary')};
        padding: 8px 0;
      }
    }
  }

  a {
    width: 100%;
    @media (${breakpoint.mdMin}) {
      width: max-content;
    }
  }
`;

export const Description = styled.summary<{ theme: Theme }>`
  ${getBodyStyle('graphikCompact', { default: 'default' })}
`;
